import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from './rest.service';
import { InvoiceGetPdfRequest, InvoiceQueryFilter, InvoiceQueryRequest, InvoiceQueryResponse, InvoiceQueryResponseSchema } from '../../interfaces/invoice.interface';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class InvoicesRestService {

  constructor(private restService: RestService) {
  }

  getInvoices(filter: InvoiceQueryRequest): Observable<InvoiceQueryResponse> {
    filter = {
      ...filter,
      invoiceType: filter.invoiceType ? `'${filter.invoiceType}'` : undefined,
      pageNumber: filter.pageNumber + 1, // 1 = first page
    }
    return this.restService.post(`/Invoice/query`, filter).pipe(
      map(response => InvoiceQueryResponseSchema.parse(response))
    );
  }

  getInvoiceAsDocument(request: InvoiceGetPdfRequest): Observable<Blob> {
    return this.restService.getBlobData(`/Invoice/getInvoiceDocument?InvoiceNumber=${request.invoiceNumber}&Source=${request.source}&InvoiceDate=${request.invoiceDate}&ESoftId=${request.eSoftId}&SoldToId=${request.soldToId}`);
  }

  getInvoicesAsExcel(filter: InvoiceQueryFilter): Observable<Blob> {
    filter = {
      ...filter,
      invoiceType: filter.invoiceType ? `'${filter.invoiceType}'` : undefined,
    };
    return this.restService.getBlobData(`/Invoice/listInvoicesAsDocument`, filter);
  }
}
